/** Unique predicate to be used with array filter */
export function unique<T>(value: T, index: number, values: T[]) {
  return values.indexOf(value) === index;
}
